import { render, staticRenderFns } from "./GStudentAllCompetencyGrowthChart.vue?vue&type=template&id=e4fcd726&scoped=true&"
import script from "./GStudentAllCompetencyGrowthChart.vue?vue&type=script&lang=ts&"
export * from "./GStudentAllCompetencyGrowthChart.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentAllCompetencyGrowthChart.vue?vue&type=style&index=0&id=e4fcd726&scoped=true&lang=scss&"
import style1 from "./GStudentAllCompetencyGrowthChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fcd726",
  null
  
)

export default component.exports